import React from "react";
import "@/App.css";
import Home from "@/components/home/home";
import DefaultLayout from "./layout";
import { Route, Routes } from "react-router";
import {
  BrowserRouter
} from "react-router-dom";
import FaqLayout from "@/layout/default/FaqLayout";
import Faq from "@/components/faq/faq";
import ManifestoPage from "@/components/manifesto/ManifestoPage";
import RvltPage from "@/components/rvlt/RvltPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<DefaultLayout >
          <Home />
        </DefaultLayout>} />
        <Route path="/faqs" element={<FaqLayout >
          <Faq />
        </FaqLayout>} />
        <Route path="/manifesto" element={<FaqLayout>
          <ManifestoPage />
        </FaqLayout>} />
        <Route path="/rvlt" element={<FaqLayout>
          <RvltPage />
        </FaqLayout>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
